/* eslint-disable no-trailing-spaces */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable guard-for-in */
/* eslint-disable prefer-const */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import format from 'date-fns/format';
import firebase from 'firebase/compat/app';
import { concatMap, map, tap } from 'rxjs/operators';
import { NgrxService } from 'src/app/services';
import { environment } from 'src/environments/environment';

export enum LearningOption {
	syllabus = 'syllabus',
	syllabusPeople = 'syllabus_people',
	resources = 'resources',
	notes = 'notes',
	modules = 'modules',
	events = 'events',
	assignment = 'assignment',
	announcement = 'announcement',
	students = 'students',
	highLights = 'highLights',
}

@Injectable()
export class LearningService {
	serviceName = 'learning';
	constructor(private http: HttpClient, private ngrxService: NgrxService) {}

	// Modules functions
	loadModulesInit(cohortId: number) {
		this.ngrxService.init(this.serviceName, cohortId, LearningOption.modules);
	}

	loadModulesAPI(cohortId: number) {
		return this.ngrxService
			.loadInitAPI(this.serviceName, cohortId, LearningOption.modules)
			.pipe(
				concatMap(() =>
					this.http.get<any>(
						`${environment.url.cohort}/${cohortId}/modules/V2`,
					),
				),
				map(data =>
					data.map(week => ({
						...week,
						classes: week.classes.map(tempClass => ({
							...tempClass,
							type: 'class',
						})),
					})),
				),
				map((data: any) => {
					if (data.length > 0) {
						const newObj = [...data].sort((anxPrevious, anxNext) => {
							const a: any = new Date(anxPrevious.startDateTime);
							const b: any = new Date(anxNext.startDateTime);
							return a - b;
						});

						const first = newObj[0];
						const last = newObj[newObj.length - 1];

						return [
							{
								id: 0,
								name: `${first.name.split(' ')[0]} 00`,
								description: 'default 0',
								startDateTime: first.startDateTime - 2700000000,
								endDateTime: first.startDateTime,
								classes: [],
								scheduleList: [],
							},
							...newObj,
							{
								id: last.id + 1,
								name: `${last.name.split(' ')[0]} ${Number(data.length) + 1}`,
								description: 'default ' + last.id + 1,
								classes: [],
								startDateTime: last.endDateTime,
								endDateTime: last.endDateTime + 2700000000,
								scheduleList: [],
							},
						];
					} else {
						return data;
					}
				}),
				tap(data =>
					this.ngrxService.loadInitData(
						this.serviceName,
						cohortId,
						LearningOption.modules,
						data,
					),
				),
			);
	}

	loadModulesData(cohortId: number) {
		return this.ngrxService.loadData(
			this.serviceName,
			cohortId,
			LearningOption.modules,
		);
	}

	// Class & Events functions & announcement

	loadAnnouncementInit(cohortId: number) {
		this.ngrxService.init(
			this.serviceName,
			cohortId,
			LearningOption.announcement,
		);
	}

	loadAnnouncementData(cohortId: number) {
		return this.ngrxService.loadData(
			this.serviceName,
			cohortId,
			LearningOption.announcement,
		);
	}

	loadClassAndEventsInit(cohortId: number) {
		this.ngrxService.init(this.serviceName, cohortId, LearningOption.events);
	}

	loadClassAndEventsAPI(cohortId: number) {
		return this.ngrxService
			.loadInitAPI(this.serviceName, cohortId, LearningOption.events)
			.pipe(
				concatMap(() =>
					this.http
						.get<any>(
							`${environment.url.cohort}/${cohortId}/student/${
								firebase.auth().currentUser?.email
							}/events/all`,
						)
						.pipe(
							tap(data => {
								let eventsData = [];
								let officeHoursData: any = [];

								if (data) {
									eventsData =
										data?.events?.webinar?.length > 0
											? data?.events?.webinar
											: [];

									if (data?.events['office-hours']?.length > 0) {
										officeHoursData = data.events['office-hours'];
									}
								}

								let events =
									eventsData.length > 0
										? eventsData.map((event: any) => ({
												...event,
												name: 'Event: ' + event.summary,
										  }))
										: [];

								if (officeHoursData.length > 0) {
									officeHoursData.filter((event: any) => {
										events.push({
											...event,
											name: 'Event: ' + event.summary,
											type: 'webinar',
										});
										return true;
									});
								}
								this.ngrxService.loadInitData(
									this.serviceName,
									cohortId,
									LearningOption.events,
									events,
								);
							}),
							tap(data => {
								let eventsData = [];
								if (data) {
									eventsData =
										data?.events?.announcement?.length > 0
											? data?.events?.announcement
											: [];
								}

								this.ngrxService.loadInitData(
									this.serviceName,
									cohortId,
									LearningOption.announcement,
									eventsData.filter(({ dismissed }) => !dismissed),
								);
							}),
						),
				),
			);
	}

	loadClassAndEventsData(cohortId: number) {
		return this.ngrxService.loadData(
			this.serviceName,
			cohortId,
			LearningOption.events,
		);
	}

	// Assignments functions

	loadAssignmentsInit(cohortId: number) {
		this.ngrxService.init(
			this.serviceName,
			cohortId,
			LearningOption.assignment,
		);
	}

	loadAssignmentsAPI(cohortId: number) {
		return this.ngrxService
			.loadInitAPI(this.serviceName, cohortId, LearningOption.assignment)
			.pipe(
				concatMap(() =>
					this.http
						.get<any>(
							`${environment.url.cohort}/${cohortId}/student/${
								firebase.auth().currentUser?.email
							}/assignments/V2`,
						)
						.pipe(
							map(data => ({
								assignments: data.assignments.map(event => ({
									...event,
									name: event.title,
									type: 'assignments',
								})),
							})),
							map(({ assignments }) => assignments),
						),
				),
				tap(data =>
					this.ngrxService.loadInitData(
						this.serviceName,
						cohortId,
						LearningOption.assignment,
						data,
					),
				),
			);
	}

	loadAssignmentsData(cohortId: number) {
		return this.ngrxService.loadData(
			this.serviceName,
			cohortId,
			LearningOption.assignment,
		);
	}

	// Resources functions
	loadResourcesInit(cohortId: number) {
		this.ngrxService.init(this.serviceName, cohortId, LearningOption.resources);
	}

	loadResourcesAPI(cohortId: number) {
		return this.ngrxService
			.loadInitAPI(this.serviceName, cohortId, LearningOption.resources)
			.pipe(
				concatMap(() =>
					this.http.get<any>(`${environment.url.cohort}/${cohortId}/materials`),
				),
				tap(data =>
					this.ngrxService.loadInitData(
						this.serviceName,
						cohortId,
						LearningOption.resources,
						data,
					),
				),
			);
	}

	loadResourcesData(cohortId: number) {
		return this.ngrxService.loadData(
			this.serviceName,
			cohortId,
			LearningOption.resources,
		);
	}

	// Notes functions
	loadNotesInit(cohortId: number) {
		this.ngrxService.init(this.serviceName, cohortId, LearningOption.notes);
	}

	loadNotesAPI(cohortId: number) {
		return this.ngrxService
			.loadInitAPI(this.serviceName, cohortId, LearningOption.notes)
			.pipe(
				concatMap(() =>
					this.http.get<any>(
						`${environment.url.cohort}/${cohortId}/student/${
							firebase.auth().currentUser?.email
						}/notesWithClass`,
					),
				),
				map((notes: any) => {
					let notess: any = [];
					for (const note in notes) {
						let olNotes: any = notes[note];
						let multimedia: string = '';
						let uniqueValue = olNotes?.notes
							?.map(no => no.slideIndex)
							.filter((item, i, ar) => ar.indexOf(item) === i);
						let newNotes: any = [];
						for (const unique in uniqueValue) {
							const firstRight = olNotes?.notes
								?.filter(no => no.slideIndex === uniqueValue[unique])
								.map(no => ({
									...no,
									formatDate: format(
										new Date(no.createdAt),
										`dd MMM yyyy 'at' hh:mm a`,
									),
								}));
							newNotes.push({
								...firstRight[0],
								href: `https://textbook.terra.do/class/${
									olNotes.classId
								}?slideNumber=${firstRight[0].slideIndex + 1}`,
								slides: firstRight,
							});

							const exMultimedia = firstRight
								.filter(res => !!res.multimedia)
								.filter(res => res.multimedia !== ' ')
								.map(res => res.multimedia)[0];

							if (!!exMultimedia) {
								multimedia = exMultimedia;
							}

							if (!!multimedia && multimedia.indexOf('youtube.com') > -1) {
								try {
									const match = multimedia
										.split('?')[1]
										.split('&')
										.filter(str => str.indexOf('v=') > -1)[0]
										.split('=')[1];
									multimedia = `https://img.youtube.com/vi/${match}/3.jpg`;
								} catch (e) {}
							}
						}
						notess.push({
							classId: olNotes.classId,
							classTitle: olNotes.classTitle,
							classSlides: newNotes,
							multimedia,
						});
					}
					return notess;
				}),
				tap(data =>
					this.ngrxService.loadInitData(
						this.serviceName,
						cohortId,
						LearningOption.notes,
						data,
					),
				),
			);
	}

	loadNotesData(cohortId: number) {
		return this.ngrxService.loadData(
			this.serviceName,
			cohortId,
			LearningOption.notes,
		);
	}

	// Syllabus functions
	loadSyllabusInit(cohortId: number) {
		this.ngrxService.init(this.serviceName, cohortId, LearningOption.syllabus);
	}

	loadSyllabusAPI(cohortId: number) {
		return this.ngrxService
			.loadInitAPI(this.serviceName, cohortId, LearningOption.syllabus)
			.pipe(
				concatMap(() =>
					this.http
						.get<any>(`${environment.url.cohort}/${cohortId}/syllabus`)
						.pipe(
							map(data => ({
								data:
									data.longDescription.length > 0
										? [{ longDescription: data.longDescription }]
										: [],
							})),
							map(({ data }) => data),
						),
				),
				tap(data =>
					this.ngrxService.loadInitData(
						this.serviceName,
						cohortId,
						LearningOption.syllabus,
						data,
					),
				),
			);
	}

	loadSyllabusData(cohortId: number) {
		return this.ngrxService.loadData(
			this.serviceName,
			cohortId,
			LearningOption.syllabus,
		);
	}

	// Syllabus Instructor functions
	loadSyllabusInstructorInit(cohortId: number) {
		this.ngrxService.init(
			this.serviceName,
			cohortId,
			LearningOption.syllabusPeople,
		);
	}

	loadSyllabusInstructorAPI(cohortId: number) {
		return this.ngrxService
			.loadInitAPI(this.serviceName, cohortId, LearningOption.syllabusPeople)
			.pipe(
				concatMap(() =>
					this.http.get<any>(`${environment.url.cohort}/${cohortId}/people`),
				),
				tap(data =>
					this.ngrxService.loadInitData(
						this.serviceName,
						cohortId,
						LearningOption.syllabusPeople,
						data,
					),
				),
			);
	}

	loadSyllabusInstructorData(cohortId: number) {
		return this.ngrxService.loadData(
			this.serviceName,
			cohortId,
			LearningOption.syllabusPeople,
		);
	}

	// Students functions
	loadStudentsInit(cohortId: number) {
		this.ngrxService.init(this.serviceName, cohortId, LearningOption.students);
	}

	loadStudentsAPI(cohortId: number) {
		return this.ngrxService
			.loadInitAPI(this.serviceName, cohortId, LearningOption.students)
			.pipe(
				concatMap(() =>
					this.http.get<any>(
						`${environment.url.cohort}/v2/${cohortId}/students`,
					),
				),
				tap(data =>
					this.ngrxService.loadInitData(
						this.serviceName,
						cohortId,
						LearningOption.students,
						data,
					),
				),
			);
	}

	loadStudentsData(cohortId: number): any {
		return this.ngrxService.loadData(
			this.serviceName,
			cohortId,
			LearningOption.students,
		);
	}

	deleteAnnouncementApi(id) {
		return this.http.post(`${environment.url.cohort}/dismiss/event/${id}`, {});
	}

	markRecordingViewed(eventId, type) {
		return this.http.get(
			`${environment.url.cohort}/join/${
				firebase.auth().currentUser?.email
			}/${type}/${eventId}`,
		);
	}

	editState(stateKey, cohortId, eventId, dataId, key, value) {
		this.ngrxService.editInState(
			this.serviceName,
			cohortId,
			stateKey,
			dataId,
			eventId,
			value,
			key,
		);
	}

	loadSideMenuData() {
		this.ngrxService.loadData('side');
	}

	rateAssignment(cohortId, eventId, eventType, email, rates, eventFeedback) {
		return this.http.post(`${environment.url.cohort}/events/feedback/`, {
			cohortId,
			eventId,
			eventType,
			email,
			rates,
			eventFeedback,
		});
	}
}
